/**
 * ScenarioStatusChip - Standardized status indicator for scenarios
 *
 * Renders differently in retro vs light mode:
 * - Retro: plain mono text, color-coded
 * - Light: MUI Chip with teal/gray background
 */

import React from 'react';
import { Chip, Typography } from '@mui/material';
import { useThemeMode } from '../theme-mode/useThemeMode.js';
import { vortxColors, vortxTypography } from '../core/theme.js';
import { retroColors } from '../core/theme.js';

export default function ScenarioStatusChip({ hasResults, label }) {
    const { isRetro } = useThemeMode();

    const displayLabel = label || (hasResults ? 'Completed' : 'Draft');

    if (isRetro) {
        return (
            <Typography sx={{
                fontFamily: vortxTypography.mono,
                fontSize: '0.7rem',
                color: hasResults ? '#5fd4c4' : retroColors.muted,
                textTransform: 'uppercase',
            }}>
                {displayLabel}
            </Typography>
        );
    }

    return (
        <Chip
            label={displayLabel}
            size="small"
            sx={{
                bgcolor: hasResults
                    ? `rgba(63, 106, 100, 0.2)`
                    : `rgba(166, 161, 155, 0.2)`,
                color: hasResults ? vortxColors.teal : 'text.secondary',
                fontWeight: 600,
                fontSize: '0.7rem',
                height: 22,
                '& .MuiChip-label': { px: 1 },
            }}
        />
    );
}
